import ApiService from './api.service';

const ParkService = {

  async getParkList(criteria) {
    return new Promise((resolve, reject) => {
      ApiService.getAuthenticatedInstance().post(`park/list`, criteria)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async saveParkApplication(application) {
    return new Promise((resolve, reject) => {
      ApiService.getAuthenticatedInstance().post(`/park/apply`, application)
        .then(response => {
          resolve(response.data.application)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  async getParkApplication(parkId) {
    return new Promise((resolve, reject) => {
      ApiService.getAuthenticatedInstance().get(`park/${parkId}/application`)
        .then(response => {
          resolve(response.data.application)
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async getApplicationArtCategoryList() {
    return new Promise((resolve, reject) => {
      ApiService.getAuthenticatedInstance().get(`enum/parkApplicationArtCategoryList`)
        .then(response => resolve(response.data))
        .catch(err => {
          reject(err);
        });
    });
  },

  async saveParkApplicationArt(applicationArt) {
    return new Promise((resolve, reject) => {
      ApiService.getAuthenticatedInstance().post(`park/application/art/save`, applicationArt)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}

export default ParkService;